import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import type { TransactionStore } from '../stores';

@singleton()
export class TransactionStoreFacade {
  public get originalStore() {
    return container.resolve<TransactionStore>('transactionStore');
  }

  public get subpageProperty() {
    return this.originalStore.subpageProperty;
  }
  public get subscriptions() {
    return this.originalStore.subscriptions;
  }

  public get offers() {
    return this.originalStore.offers;
  }

  public get heroes() {
    return this.originalStore.heroes;
  }

  public get subscriptionsReady() {
    return this.originalStore.subscriptionsReady;
  }

  public get isPurchaseAllowed() {
    return this.originalStore.isPurchaseAllowed;
  }

  public get isSubscriptionPurchaseAllowed() {
    return this.originalStore.isSubscriptionPurchaseAllowed;
  }

  public get isPpvPurchaseAllowed() {
    return this.originalStore.isPpvPurchaseAllowed;
  }

  public get lastDigits() {
    return this.originalStore.lastDigits;
  }

  @action.bound
  async initSubscriptions(): Promise<void> {
    return this.originalStore.initSubscriptions();
  }

  @action.bound
  async loadMainSubscriptions(): Promise<void> {
    return this.originalStore.loadMainSubscriptions();
  }

  @action.bound
  getSubscriptionByPackageId(packageId: number) {
    return this.originalStore.getSubscriptionByPackageId(packageId);
  }
}
